import { Component, inject } from '@angular/core';
import { IonButton } from '@ionic/angular/ion-button';
import { IonContent } from '@ionic/angular/ion-content';
import { TranslocoPipe } from '@jsverse/transloco';
import { Browser } from '@capacitor/browser';
import { ModalService } from '@services/utility-services/modal.service';
import { IconDisplayComponent } from '@shared/components/icon-display/icon-display.component';
import { resolveDocumentTypeLabel } from '@shared/utils/translation.helper';
import { TaskNotificationModalDataModel } from '@shared/models/notification/task-notification-modal-data.model';

@Component({
  selector: 'app-signature-modal',
  templateUrl: './signature-modal.component.html',
  styleUrls: ['./signature-modal.component.scss'],
  imports: [
    IonContent,
    TranslocoPipe,
    IonButton,
    IconDisplayComponent
  ]
})
export class SignatureModalComponent {
  public notification: TaskNotificationModalDataModel | null = null;

  protected readonly modalService = inject(ModalService);

  protected readonly getDocumentTypeLabel = resolveDocumentTypeLabel;

  protected async openExternalWebsiteAsync(link: string | null | undefined): Promise<void> {
    if (!link) {
      return;
    }

    await Browser.open({ url: link });
    this.modalService.closeModal();
  }
}
